import React from 'react';
import { useTranslation } from 'react-i18next';
import { EmailNameInput } from './inputs/EmailInput';
import { InviteFormTermsType, InviteTermsCheckbox } from './InviteTermsCheckbox';
import { ExtendedUseFormReturn } from '../../../../../hooks/providers/useFormHooks';
import { InviteFormType } from '../InviteFormStep';

interface AccountantFormProps {
  formMethods: ExtendedUseFormReturn<InviteFormType>;
  onTermsClick: (type: InviteFormTermsType) => void;
}

export const AccountantForm = ({ formMethods, onTermsClick }: AccountantFormProps) => {
  const { t } = useTranslation('inviteEN');

  return (
    <form onSubmit={(event) => event.preventDefault()} id='rhfWrapper' className='flex flex-col w-full'>
      <div className='flex flex-col w-full'>
        <EmailNameInput control={formMethods.control} title={t('INVITE_FORM.INPUTS.EMAIL.ACCOUNTANT')} />
      </div>
      <InviteTermsCheckbox
        formMethods={formMethods}
        onTermsClick={() => onTermsClick(InviteFormTermsType.ACCOUNTANT_VIEWER_TERMS)}
        type={InviteFormTermsType.ACCOUNTANT_VIEWER_TERMS}
        title={t('INVITE_FORM.CHECKBOX.ACCOUNTANT.VIEWER_TERMS.TITLE')}
        linkText={t('INVITE_FORM.CHECKBOX.ACCOUNTANT.VIEWER_TERMS.LINK')}
      />
    </form>
  );
};
